<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <q-page>
    <div class="justify-center row">
      <div v-if="cart" class="col-11 q-pa-md">
        <h2 class="q-mt-sm q-mb-lg text-center">Cart Summary</h2>
        <h4 class="q-mt-sm q-mb-lg text-center">
          <span style="cursor: pointer;">
            ({{cart.name}})
            <edit-cart-menu store-type="stock"/>
          </span>
        </h4>
        <h4 class="q-mt-none q-mb-md">Total Holds In Cart: {{totalHolds}}</h4>
        <div class="row q-mb-lg">
          <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 q-pa-sm">
            <summary-table
              title="Brand"
              :items="cart.items"
            />
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 q-pa-sm">
            <summary-table
              title="Type"
              :items="cart.items"
            />
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 q-pa-sm">
            <summary-table
              title="Material"
              :items="cart.items"
            />
          </div>
<!--          <div class="col-6 col-md-2 q-pa-sm">-->
<!--            <summary-table-->
<!--              title="Size"-->
<!--              :items="cart.items"-->
<!--              :sort-callback="(a, b) => sizeSort(a.group, b.group)"-->
<!--            />-->
<!--          </div>-->
<!--          <div class="col-12 col-md-2 q-pa-sm">-->
<!--            <summary-table-->
<!--              title="Grip"-->
<!--              :items="cart.items"-->
<!--            />-->
<!--          </div>-->
          <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 q-pa-sm">
            <summary-table
              title="Colour"
              :items="cart.items"
              :group-field-callback="row => getNestedFieldInObject('sku.options.colour.group', row)">
              <template v-slot:group="props">
                <div :style="{
                  border:'1px solid silver',
                  backgroundColor: getNestedFieldInObject('row.item.sku.options.colour.hex', props),
                  width: '10px',
                  height: '10px'
                }" class="inline-block">
                </div>
                {{props.row.group}}
              </template>
            </summary-table>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 q-pa-sm">
            <summary-table
              title="Screws You'll Need"
              sumName="Qty"
              groupName="Length"
              :items="cart.items"
              :group-field-callback="row => getProductAttributeFromRow('screws', row).map(x => x.type)"
              :sum-callback="row => getProductAttributeFromRow('screws', row).map(x => x.qty * row.qty)"
              :hide-price-column="true"
            />
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 q-pa-sm">
            <summary-table
              title="Bolts You'll Need"
              sumName="Qty"
              groupName="Length"
              :items="cart.items"
              :group-field-callback="row => getProductAttributeFromRow('bolts', row).map(x => x.type)"
              :sum-callback="row => getProductAttributeFromRow('bolts', row).map(x => x.qty * row.qty)"
              :hide-price-column="true"
            />
          </div>
        </div>
        <q-table
          :data="cart.items"
          :columns="cartColumns"
          :pagination.sync="pagination"
          class="my-sticky-column-table"
          hide-bottom
          binary-state-sort
          row-key="name" >

          <template v-slot:body-cell-ETA="props">
            <q-td>
              <div v-if="props.value != 'Invalid date'" style=" 
                color: white; 
                font-weight:bold;
                background-color: black;
                text-align:center; 
                margin: 0px; 
                border-radius: 5px; 
                border: 1px solid black;
                width:80px
                ">{{props.value}}</div>
            </q-td>
          </template>          

          <template v-slot:body-cell-img="props">
            <q-td>
              <q-img dense :src="props.value + '.png.thumb'" style="width: 60px; height: 60px;" contain>
                <q-tooltip anchor="center right" self="center left" :offset="[10, 10]"
                           transition-show="scale"
                           transition-hide="scale"
                           content-style="background: white; border: solid 1px black">
                  <q-img dense :src="props.value" style="width: 25vw; height: 25vw;" contain/>
                </q-tooltip>
              </q-img>
            </q-td>
          </template>

          <template v-slot:body-cell-colour="props">
            <q-td :props="props">
              <div :style="{border: '1px silver solid', backgroundColor: props.row.sku.options.colour.hex, width: '10px',height: '10px',marginRight:'5px'}" class="inline-block"></div>
              {{props.row.sku.options.colour.group + ' (' + props.row.sku.options.colour.name + ')'}}
            </q-td>
          </template>          

          <template v-slot:body-cell-qty="props">
            <q-td key="qty" style="min-width: 100px" :props="props" auto-width>
              <span class="q-pr-sm">
                <span v-if="!findSkuError(props.row)">{{ props.value }}</span>
                <q-badge color="red" v-else>
                  {{ props.value }} <q-icon name="warning" color="white" class="q-ml-xs" />
                  <q-tooltip content-style="font-size: 1em">{{getUserFriendlyErrorMessage(findSkuError(props.row))}}</q-tooltip>
                </q-badge>
                <m-popup-edit v-if="props.row.sku"
                              v-model="props.value"
                              @save="v => editCartItemQty(props.row, v)"
                              input-type="number"
                              min="1"
                              :max="(props.row.sku||{}).stock || 0"
                              :rules="[val => Number(val) <= Number((props.row.sku||{}).stock) || `Only ${(props.row.sku||{}).stock || 0} in stock!`,
                                       val => Number(val) > 0 || `Please chose at least 1.`]" />
              </span>
              <q-btn dense flat size="xs" icon="delete" color="red"
                     @click="deleteCartItemWithConfirmation(props.row.id)" />
            </q-td>
          </template>

          <template v-slot:no-data="{ icon, message, filter }">
            <div class="full-width column flex-center text-accent q-gutter-sm">
              <p class="q-mb-none">
                <img
                  src="../../assets/holds_2.png"
                  style="width:70px;">
              </p>
              <p class="q-mt-none">You have no holds in your cart.</p>
            </div>
          </template>
        </q-table>
        <div class="text-right q-pt-sm">
          *Bolts are not included
        </div>
        <div class="text-h4 q-pt-md text-right">
          Total Cost: ${{ Number(totalCost * storeDiscount).toFixed(2) }}
        </div>
        <div class="text-h5 text-right text-grey">
          Includes GST: ${{ Number(totalCost * storeDiscount * (1-1/1.1)).toFixed(2) }}
        </div>
        <m-edit-item autogrow filled field="notes" type="input" graphqlType="Cart" :id="cartId" />
        <!-- <h4>Conditions</h4> -->
        <br>
        <div v-if="isPreStock">
          <p style="font-size:20px">Hold up! There are a couple of things to check before placing your order.</p>
        <div>
          <ul>
            <li>Domestic shipping isn't included in this price</li>
            <li>Arrival dates on pre-ordered items are estimates and are subject to change</li>
            <li>We will do our best to group your order together. However, split shipments will incur additional shipping and handling fees.</li>
            <li>Payment plans for this order are not available, order must be paid in full before the due date to avoid order cancellations</li>
          </ul>
        </div>
        <div>
          <q-checkbox v-model="agreeShipping" label="I agree these terms" style="font-weight:bold" /><br />
          <q-checkbox v-model="allowSubstitution" label="Allow Substitution - If an item is not available, you may get a substitution with a similar item." />
        </div>  
        </div>
      
        <div class="text-right" v-else>
          <q-checkbox left-label v-model="agreeShipping" 
          label="Hold up! Click here to confirm that you know domestic shipping isn't included in this price, and will be charged when we ship these bad boys out to you." />
        </div>
        <q-btn class="q-py-sm q-px-xl q-mt-lg float-right"
               icon="shopping_cart" color="primary"
               :disable="!!cartErrors.length || !cart.items.length || !agreeShipping"
               @click="placeOrder">Place Order</q-btn>

      </div>
    </div>
  </q-page>
</template>

<script>
import gql from 'graphql-tag'
import getNestedFieldInObject from '@/util/getNestedFieldInObject'
import MPopupEdit from '../../components/ui/MPopupEdit'
import SummaryTable from '../../components/summaryTable'
import EditCartMenu from '../../components/EditCartMenu'
import MEditItem from '../../components/ui/admin/MEditItem'
import { colourToString, formatCurrency } from '../../util/string'
import moment from "moment";


export default {
  name: 'PageStockCart',
  components: { MEditItem, EditCartMenu, SummaryTable, MPopupEdit },
  apollo: {
    validateCart () {
      return {
        query: gql`query validateCart ($cartId: ID!) {
            validateCart (id: $cartId)
        }`,
        variables () {
          return {
            cartId: this.cartId
          }
        },
        skip: () => !this.cartId,
        fetchPolicy: 'no-cache',
        async result (result) {
          // Clear all warnings
          if (result.data.validateCart === true) this.cartErrors = []
        },
        error (error) {
          // Error is stored in a rather confusing structure.  See if future apollo updates break this... :(
          const parentCartValidationError = error.graphQLErrors?.find(v => v.extensions?.exception?.name === 'CartValidationErrors')?.extensions?.exception || {}
          this.cartErrors = parentCartValidationError?.errors || []
        }
      }
    },
    cart () {
      return {
        query: gql`
          query cart ($id: ID!) {
            cart(id: $id) {
              id,
              name,
              notes,
              items {
                id,
                skuId,
                qty,
                stockType
                ETA
                sku {
                  id,
                  stock,
                  price,
                  attributes,
                  options,
                  product {
                      id,
                      name,
                      images {
                        url
                        name
                      },
                      attributes,
                      urlSlug
                  }
                  showPreStock
                  preStock
                  availableOn   
                }
              }
            }
          }
        `,
        variables () {
          return {
            id: this.cartId
          }
        },
        async result ({ data }) {
          try {
            await this.$apollo.queries.validateCart.refetch()
          } catch (ex) {
          }
          return data.cart
        },
        skip: () => !this.cartId,
        error (error) {
          if (error.message === `GraphQL error: Cart with id ${this.cartId} does not exist.`) {
            // createNewActiveCart
          }
        }
      }
    }
  },
  computed: {
    storeType(){
      return this.$store.state.cart.currentStoreType
    },
    currentAccount () {
      return this.$store.state.auth.currentAccount
    },
    cartId () {
      return this.currentAccount?.activeCartId
    },
    totalCost () {
      return (this.cart?.items || []).reduce((p, c, i) => p + ((c.sku?.price || 0) * Number(c.qty)), 0)
    },
    totalHolds () {
      return (this.cart?.items || []).reduce((p, c, i) => p + ((c.sku?.product?.attributes?.holds || 0) * Number(c.qty)), 0)
    },
    totalSets() {
      return this.cart?.items?.reduce((p, c, i) => p + Number(c.qty), 0); 
    },
    isPreStock(){
      return this.getIsPreStock();
    },
    storeDiscount(){
      if(this.storeType === "stock"){
        return (100 - this.$store.state.auth.storeSettings.stockStoreDiscount)/100
      }else{
        return 1
      }
    },            
  },
  methods: {
    getIsPreStock(){
      let preStock = false
      for(let item of this.cart.items){
        if(item.stockType == "pre-stock")
          preStock = true
      }
      return preStock
    },
    getNestedFieldInObject: getNestedFieldInObject,
    getProductAttributeFromRow (attributeName, row) {
      return this.getNestedFieldInObject(`sku.product.attributes.${attributeName}`, row) || []
    },
    colourToString: colourToString,
    findSkuError (row) {
      return this.cartErrors.find(e => e.skuId === row.sku?.id)
    },
    getUserFriendlyErrorMessage (error) {
      if (error.name === 'NotEnoughStockError') {
        if (!error.available) return `${error.available} items in stock`
        return `Only ${error.available} items in stock`
      }
      if (error.name === 'SkuDoesNotExistError') {
        return `Sku does not exist.`
      }
    },
    editCartItemQty (row, qty) {
      qty = Number(qty)
      if (qty <= 0) {
        this.deleteCartItemWithConfirmation(row?.id)
        return
      }      
      this.editCartItem(row?.sku?.id, { qty, stockType: row?.stockType, ETA: row?.sku?.availableOn})
    },
    // editCart (changes) {
    //   this.$apollo.mutate({
    //     mutation: gql`
    //       mutation editCart($cartId: ID!, $input: CartInput!) {
    //         editCart(id: $cartId, input: $input) {
    //           id,
    //           name,
    //           notes,
    //           items {
    //             id,
    //             skuId,
    //             qty,
    //             stockType,
    //             ETA                 
    //             sku {
    //               id,
    //               stock,
    //               price,
    //               attributes,
    //               options,
    //               product {
    //                 id,
    //                 name,
    //                 images {
    //                   url
    //                   name
    //                 },
    //                 attributes,
    //                 urlSlug,
    //               }
    //             }
    //           }
    //         }
    //       }`,
    //     variables: {
    //       cartId: this.cartId,
    //       input: changes
    //     }
    //   }).catch(err => {
    //     console.log(err)
    //     this.$q.notify({
    //       message: 'Error updating!',
    //       color: 'negative',
    //       icon: 'report_problem'
    //     })
    //   })
    // },
    deleteCartItemWithConfirmation (skuId) {
      this.$q.dialog({
        title: 'Remove',
        message: 'Are you sure you want to remove this item from your cart?',
        cancel: true,
        persistent: true
      }).onOk(() => {
        this.deleteCartItem(skuId)
      })
    },
    async deleteCartItem (itemId) {
      try {
        await this.$apollo.mutate({
          mutation: gql`
            mutation deleteItemFromCartByItemId($cartId: ID!, $itemId: ID!) {
              deleteItemFromCartByItemId(id: $cartId, itemId: $itemId) {
                id,
                name,
                notes,
                items {
                  id,
                  skuId,
                  qty,                   
                  sku {
                    id,
                    stock,
                    price,
                    attributes,
                    options,
                    product {
                      id,
                      name,
                      images {
                        url
                        name
                      },
                      attributes,
                      urlSlug,
                    }
                  }
                }
              }
            }`,
          variables: {
            cartId: this.cartId,
            itemId
          }
        })
        // eslint-disable-next-line no-undef
        analytics.track('Delete Item From Cart', {
          storeType: this.$store.state.cart.currentStoreType,
          cartId: this.cartId,
          where: 'cart',
          itemId
        })
      } catch (err) {
        console.log(err)
        this.$q.notify({
          message: 'Error updating!',
          color: 'negative',
          icon: 'report_problem'
        })
      }
      this.$store.commit('cart/setCartStockQty', this.totalSets);
    },
    async editCartItem (skuId, updates) {
      try {
        await this.$apollo.mutate({
          mutation: gql`mutation editItemInCart($cartId: ID!, $skuId: ID!, $input: CartItemInput!) {
            editItemInCart(id: $cartId, skuId: $skuId, input: $input) {
              id,
              name,
              notes,
              items {
                id,
                skuId,
                qty,
                stockType,                
                sku {
                  id,
                  stock,
                  price,
                  attributes,
                  options,
                  product {
                    id,
                    name,
                    images {
                      url
                      name
                    },
                    attributes,
                    urlSlug,
                  }
                }
              }
            }
          }`,
          variables: {
            cartId: this.cartId,
            skuId: skuId,
            input: updates
          }
        })
        // eslint-disable-next-line no-undef
        analytics.track('Edit Item In Cart', {
          storeType: this.$store.state.cart.currentStoreType,          
          cartId: this.cartId,
          skuId,
          updates
        })
      } catch (error) {
        console.log(error)
        this.$q.notify({
          message: 'Error updating!',
          color: 'negative',
          icon: 'report_problem'
        })
      }
      this.$store.commit('cart/setCartStockQty', this.totalSets);
    },
    async setDiscount(id,discountPercent){
        try {
          await this.$apollo.mutate({
            mutation: gql`mutation setDiscountOnAllOrderItems($orderId: ID!, $discountPercent: Float!) {
            setDiscountOnAllOrderItems(id: $orderId, discountPercent: $discountPercent) {
              id
              orderNumber
              name
              notes
              createdAt
              totalCost
              account {
                id
                companyName
              }
              placed
              paid
              verified
              packed
              shipped
              delivered
              items {
                id
                skuId
                sku {
                    id
                    options
                    price
                    stock
                    product {
                        id
                        name
                        reference
                        attributes
                        images {
                          url
                        }
                        urlSlug
                    }
                }
                qty
                notes
                itemCost
                discountPercent
                totalCost
              }
            }
          }`,
            variables: {
              orderId: id,
              discountPercent: Number(discountPercent)
            }
          })
        } catch (error) {
          adminNotifyError(this.$q, 'Failed to set discount.', error)
        }   
    },
    placeOrder () {
      this.$q.dialog({
        title: 'Place Order',
        html: true,
        message: `<p>Are you ready to place your order?<br/>
The total cost will be $${Number(this.totalCost * this.storeDiscount).toFixed(2)}. (Shipping not included)<br/>
Hit the big red button to lock in your purchase and <a href="javascript:window.open('/terms-and-conditions','mypopuptitle','width=500,height=600')" >accept our T&Cs</a>.</p>`,
        persistent: true,
        ok: { label: 'yes' },
        cancel: { label: 'no', flat: true }
      }).onOk(async () => {
        try {
          let placedOrder = await this.$apollo.mutate({
            mutation: gql`
            mutation placeOrder($cartId: ID!, $allowSubstitutions: Boolean) {
              placeOrder (cartId: $cartId, allowSubstitutions: $allowSubstitutions) { id }
            }
          `,
            variables: {
              cartId: this.cartId,
              allowSubstitutions: this.allowSubstitution
            }
          })
          // eslint-disable-next-line no-undef
          analytics.track('Placed Order', {
            storeType: this.$store.state.cart.currentStoreType,
            orderId: this.cartId,
            value: this.totalCost * this.storeDiscount,
            cart: this.cart
          })
          await this.$store.dispatch('auth/fetchCurrentAccount')
          await this.$store.dispatch('cart/fetchActiveCart', 'stock')

          if(this.storeDiscount != 1){
            await this.setDiscount(placedOrder.data.placeOrder.id, 100 - (this.storeDiscount * 100))
          }

          this.$router.push(`/stock/place-order/${placedOrder.data.placeOrder.id}`)
        } catch (error) {
          console.log(error)
          this.$q.notify({
            message: 'Failed to place order!',
            color: 'negative',
            icon: 'report_problem'
          })
        }
      })
    },
    sizeSort (a, b) {
      const sizes = ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl']
      const x = sizes.indexOf(a.toLowerCase())
      const y = sizes.indexOf(b.toLowerCase())
      return x - y
    }
  },
  data () {
    return {
      agreeShipping: false,
      allowSubstitution: false,
      isPreStockOrder: false,
      pagination: {
        rowsPerPage: 0
      },
      cartErrors: [],
      cart: { items: [] },
      cartColumns: [
        { name: 'img', field: row => row.sku?.product?.images?.[0]?.url },
        { name: 'ETA', label: 'Arrives', field: row => moment(row.sku.availableOn).format('MMMM YYYY')},        
        { name: 'brand', label: 'Brand', field: row => row.sku?.product?.attributes?.brand, sortable: true },
        { name: 'range', label: 'Range', field: row => row.sku?.product?.attributes?.range, sortable: true },
        { name: 'name', label: 'Name', field: row => row.sku?.product?.name || 'Not Found', sortable: true },
        // { name: 'size', label: 'Size', field: row => row.sku?.product?.attributes?.size, sortable: true },
        // { name: 'grip', label: 'Grip', field: row => row.sku?.product?.attributes?.grip, sortable: true },
        { name: 'holds', label: 'Holds', field: row => Number(row.sku?.product?.attributes?.holds), sortable: true },
        { name: 'colour', label: 'Colour', field: row => colourToString(row.sku?.options?.colour), sortable: true },
        { name: 'price', label: 'Price', field: row => Number(row.sku?.price * this.storeDiscount), sortable: true, format: formatCurrency },
        { name: 'qty', label: 'Qty', field: row => Number(row.qty), sortable: true },
        { name: 'total', label: 'Total', field: row => Number(row.sku?.price * this.storeDiscount * row.qty), sortable: true, format: formatCurrency }
      ].map(col => ({ align: 'left', ...col }))
    }
  }
}
</script>

<style lang="stylus">
  .my-sticky-column-table
    /*
      specifying max-width so the example can
      highlight the sticky column on any browser window
    */
    /*max-width 600px*/

    /* bg color is important for th; just specify one */
    thead tr th:last-child,
    thead tr th:nth-last-child(2)
      background-color #ffffff
      opacity 1

    td:last-child,
    td:nth-last-child(2)
      background-color #ffffff

    /*tr:hover td:last-child,*/
    /*tr:hover td:nth-last-child(2)*/
    /*  background-color #eeeeee*/

    thead tr th:last-child,
    td:last-child
      position sticky
      right 0
      z-index 1

    thead tr th:nth-last-child(2),
    td:nth-last-child(2)
      position sticky
      right 76px
      z-index 1
</style>
